var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 21H14M18.5 9.5C18.5 14.1944 14.6944 18 10 18C5.30558 18 1.5 14.1944 1.5 9.5C1.5 4.80558 5.30558 1 10 1C14.6944 1 18.5 4.80558 18.5 9.5ZM13.1875 9.5C13.1875 11.2604 11.7604 12.6875 10 12.6875C8.23959 12.6875 6.8125 11.2604 6.8125 9.5C6.8125 7.73959 8.23959 6.3125 10 6.3125C11.7604 6.3125 13.1875 7.73959 13.1875 9.5Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntIcon);
export default __webpack_public_path__ + "static/media/intIcon.13cd75e32e6a0752d3ca38fc71bbf4b6.svg";
export { ForwardRef as ReactComponent };